module.exports = __webpack_public_path__ + "img/twitter.53121564.svg";